import styled from 'styled-components';

export const TimeSelectorNoTimes = styled.div`
  margin: 10px 0 30px;
  text-align: left;
`;
